import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppDeployment, HostingTypesWithCloudComplianceBoundaries, HostingTypeToFiltersQueryParam } from '@atlassian/mpac-types';
import { AtlassianProductHostingType, MarketplaceProgramStatus } from '@atlassian/mpac-types/graphql-gateway-types';
import { convertToAtlassianHostingType, MarketplaceAppUtils } from '@atlassian/mpac-utils';
import { getSelectedAppVersion, getSelectedAppVersionConnection } from '../../utils';
const makeWatcherInfo = info => {
  var _info$isUserWatchingA, _info$watchersCount;
  return {
    isUserWatchingApp: (_info$isUserWatchingA = info === null || info === void 0 ? void 0 : info.isUserWatchingApp) !== null && _info$isUserWatchingA !== void 0 ? _info$isUserWatchingA : false,
    watchersCount: (_info$watchersCount = info === null || info === void 0 ? void 0 : info.watchersCount) !== null && _info$watchersCount !== void 0 ? _info$watchersCount : 0
  };
};
export function makeHighlight(highlight, makeImageLink) {
  const {
    croppedScreenshot,
    title,
    summary,
    screenshot
  } = highlight;
  const croppedImage = croppedScreenshot.highResolution || croppedScreenshot.original;
  const image = screenshot.image.highResolution || screenshot.image.original;
  const caption = highlight.caption || screenshot.caption;
  const originalImage = screenshot.image.original || croppedScreenshot.original;
  return {
    title,
    caption,
    summary,
    croppedImage: {
      width: croppedImage.width,
      height: croppedImage.height,
      url: croppedImage.imageUrl || makeImageLink(croppedImage.id)
    },
    image: {
      width: image.width,
      height: image.height,
      url: image.imageUrl || makeImageLink(image.id)
    },
    originalImage: {
      width: originalImage.width,
      height: originalImage.height,
      url: originalImage.imageUrl || makeImageLink(originalImage.id)
    }
  };
}
export function makeScreenshot(screenshot, makeImageLink) {
  const {
    caption,
    image
  } = screenshot;
  const {
    id,
    width,
    height,
    imageUrl
  } = image.original;
  return {
    caption,
    image: {
      url: imageUrl || makeImageLink(id),
      width,
      height
    }
  };
}
const makeHeroImage = (heroImage, makeImageLink) => {
  const image = (heroImage === null || heroImage === void 0 ? void 0 : heroImage.highResolution) || (heroImage === null || heroImage === void 0 ? void 0 : heroImage.original);
  if (!image) {
    return null;
  }
  return {
    width: image.width,
    height: image.height,
    url: image.imageUrl || makeImageLink(image.id)
  };
};
export const makePartner = (partner, detailsLink, makeImageLink) => {
  var _partner$programs, _partner$support, _partner$support$cont, _partner$partnerTier;
  let logo;
  if (partner !== null && partner !== void 0 && partner.logo) {
    var _partner$logo$highRes;
    const highResImageUrl = (_partner$logo$highRes = partner.logo.highResolution) === null || _partner$logo$highRes === void 0 ? void 0 : _partner$logo$highRes.imageUrl;
    const originalImageUrl = partner.logo.original.imageUrl;
    if (highResImageUrl || originalImageUrl) {
      logo = highResImageUrl || originalImageUrl;
    } else if (makeImageLink) {
      var _partner$logo$highRes2;
      const highResImageId = (_partner$logo$highRes2 = partner.logo.highResolution) === null || _partner$logo$highRes2 === void 0 ? void 0 : _partner$logo$highRes2.id;
      const originalImageId = partner.logo.original.id;
      logo = makeImageLink(highResImageId || originalImageId);
    }
  } else {
    logo = null;
  }
  return {
    id: partner === null || partner === void 0 ? void 0 : partner.id,
    name: partner === null || partner === void 0 ? void 0 : partner.name,
    url: partner ? detailsLink.expand({
      id: partner.id,
      slug: partner.slug
    }) : null,
    programs: {
      isCloudAppSecuritySelfAssessmentDone: (partner === null || partner === void 0 ? void 0 : (_partner$programs = partner.programs) === null || _partner$programs === void 0 ? void 0 : _partner$programs.isCloudAppSecuritySelfAssessmentDone) || false
    },
    support: {
      url: partner === null || partner === void 0 ? void 0 : (_partner$support = partner.support) === null || _partner$support === void 0 ? void 0 : (_partner$support$cont = _partner$support.contactDetails) === null || _partner$support$cont === void 0 ? void 0 : _partner$support$cont.websiteUrl
    },
    partnerType: partner === null || partner === void 0 ? void 0 : partner.partnerType,
    partnerTierType: partner === null || partner === void 0 ? void 0 : (_partner$partnerTier = partner.partnerTier) === null || _partner$partnerTier === void 0 ? void 0 : _partner$partnerTier.type,
    logo
  };
};
export const makePrograms = programs => {
  var _programs$cloudFortif, _programs$bugBountyPa, _programs$bugBountyPa2, _programs$bugBountyPa3, _programs$bugBountyPa4, _programs$bugBountyPa5, _programs$bugBountyPa6;
  return {
    cloudFortified: {
      isStatusApproved: (programs === null || programs === void 0 ? void 0 : (_programs$cloudFortif = programs.cloudFortified) === null || _programs$cloudFortif === void 0 ? void 0 : _programs$cloudFortif.programStatus) === MarketplaceProgramStatus.Approved
    },
    bugBountyParticipant: {
      cloud: {
        status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa = programs.bugBountyParticipant) === null || _programs$bugBountyPa === void 0 ? void 0 : (_programs$bugBountyPa2 = _programs$bugBountyPa.cloud) === null || _programs$bugBountyPa2 === void 0 ? void 0 : _programs$bugBountyPa2.status
      },
      server: {
        status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa3 = programs.bugBountyParticipant) === null || _programs$bugBountyPa3 === void 0 ? void 0 : (_programs$bugBountyPa4 = _programs$bugBountyPa3.server) === null || _programs$bugBountyPa4 === void 0 ? void 0 : _programs$bugBountyPa4.status
      },
      dataCenter: {
        status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa5 = programs.bugBountyParticipant) === null || _programs$bugBountyPa5 === void 0 ? void 0 : (_programs$bugBountyPa6 = _programs$bugBountyPa5.dataCenter) === null || _programs$bugBountyPa6 === void 0 ? void 0 : _programs$bugBountyPa6.status
      }
    }
  };
};
export const makeReviewSummary = (enableAppReviewSummaryFromStoreBff, summary, reviewSummaryDetails) => {
  if (enableAppReviewSummaryFromStoreBff) {
    var _reviewSummaryDetails, _reviewSummaryDetails2;
    return {
      count: (_reviewSummaryDetails = reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : reviewSummaryDetails.totalCount) !== null && _reviewSummaryDetails !== void 0 ? _reviewSummaryDetails : 0,
      rating: (_reviewSummaryDetails2 = reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : reviewSummaryDetails.averageStars) !== null && _reviewSummaryDetails2 !== void 0 ? _reviewSummaryDetails2 : 0
    };
  } else {
    var _summary$count, _summary$rating;
    return {
      count: (_summary$count = summary === null || summary === void 0 ? void 0 : summary.count) !== null && _summary$count !== void 0 ? _summary$count : 0,
      rating: (_summary$rating = summary === null || summary === void 0 ? void 0 : summary.rating) !== null && _summary$rating !== void 0 ? _summary$rating : 0
    };
  }
};
export const makeSupportDetails = _ref => {
  var _partner$support2, _partner$support2$con, _partner$support3, _partner$support3$con, _partner$support4, _partner$support4$con, _partner$support5;
  let {
    selectedAppVersion,
    appDetails
  } = _ref;
  const {
    wikiUrl,
    forumsUrl,
    partner,
    issueTrackerUrl,
    supportTicketSystemUrl,
    statusPageUrl
  } = appDetails;
  const {
    documentationUrl
  } = selectedAppVersion || {};
  const resources = {
    documentationUrl,
    wikiUrl,
    forumsUrl
  };
  const isSupported = (selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.isSupported) === true;
  return {
    isSupported,
    isAtlassianCommunityEnabled: appDetails.isAtlassianCommunityEnabled || !isSupported,
    hasResources: Object.values(resources).some(url => !!url),
    resources,
    contact: {
      emailId: partner === null || partner === void 0 ? void 0 : (_partner$support2 = partner.support) === null || _partner$support2 === void 0 ? void 0 : (_partner$support2$con = _partner$support2.contactDetails) === null || _partner$support2$con === void 0 ? void 0 : _partner$support2$con.emailId,
      websiteUrl: partner === null || partner === void 0 ? void 0 : (_partner$support3 = partner.support) === null || _partner$support3 === void 0 ? void 0 : (_partner$support3$con = _partner$support3.contactDetails) === null || _partner$support3$con === void 0 ? void 0 : _partner$support3$con.websiteUrl,
      phoneNumber: partner === null || partner === void 0 ? void 0 : (_partner$support4 = partner.support) === null || _partner$support4 === void 0 ? void 0 : (_partner$support4$con = _partner$support4.contactDetails) === null || _partner$support4$con === void 0 ? void 0 : _partner$support4$con.phoneNumber,
      // support requests
      issueTrackerUrl,
      supportTicketSystemUrl,
      statusPageUrl
    },
    availability: partner === null || partner === void 0 ? void 0 : (_partner$support5 = partner.support) === null || _partner$support5 === void 0 ? void 0 : _partner$support5.availability,
    partner: {
      name: partner === null || partner === void 0 ? void 0 : partner.name
    }
  };
};
export const hasDownloadableArtifact = (deployment, hosting) => {
  if (!deployment) return false;
  const cloudPreinstalled = hosting === AtlassianProductHostingType.Cloud && deployment.__typename === AppDeployment.PLUGINS2;
  if (deployment.__typename === AppDeployment.INSTRUCTIONAL) {
    return deployment.isBinaryUrlAvailable;
  } else if (deployment.__typename === AppDeployment.WORKFLOW) {
    return deployment.isWorkflowDataFileAvailable;
  } else {
    return !MarketplaceAppUtils.isRemoteable(deployment) && !cloudPreinstalled;
  }
};
const makeInstallationInstructions = _ref2 => {
  var _selectedAppVersion$d;
  let {
    selectedAppVersion,
    listingImageRenderer
  } = _ref2;
  if (selectedAppVersion && selectedAppVersion.deployment.__typename === AppDeployment.INSTRUCTIONAL && (_selectedAppVersion$d = selectedAppVersion.deployment.instructions) !== null && _selectedAppVersion$d !== void 0 && _selectedAppVersion$d.length) {
    const {
      instructions
    } = selectedAppVersion.deployment;
    return instructions.map(_ref3 => {
      var _screenshot$highResol;
      let {
        instruction,
        screenshot
      } = _ref3;
      const screenshotImage = (_screenshot$highResol = screenshot === null || screenshot === void 0 ? void 0 : screenshot.highResolution) !== null && _screenshot$highResol !== void 0 ? _screenshot$highResol : screenshot === null || screenshot === void 0 ? void 0 : screenshot.original;
      return {
        instruction,
        screenshot: screenshotImage !== null && screenshotImage !== void 0 && screenshotImage.id ? {
          url: listingImageRenderer(screenshotImage.id),
          width: screenshotImage.width,
          height: screenshotImage.height
        } : null
      };
    });
  }
  return [];
};
const makeResourceLinks = _ref4 => {
  let {
    appDetails,
    latestVersion,
    appVersionHistoryLink,
    artifactDownloadLink,
    descriptorDownloadLink,
    hosting
  } = _ref4;
  const {
    appId,
    slug
  } = appDetails;
  const {
    deployment,
    buildNumber,
    endUserLicenseAgreementUrl,
    learnMoreUrl,
    documentationUrl,
    purchaseUrl
  } = latestVersion || {};
  return {
    endUserLicenseAgreementUrl,
    learnMoreUrl,
    documentationUrl,
    purchaseUrl,
    buildNumber,
    versionHistoryUrl: appVersionHistoryLink.expand({
      appId,
      appSlug: slug,
      hosting: HostingTypeToFiltersQueryParam[hosting]
    }),
    artifactDownloadUrl: hasDownloadableArtifact(deployment, hosting) ? artifactDownloadLink.expand({
      appId,
      buildNumber
    }) : undefined,
    descriptorDownloadUrl: (deployment === null || deployment === void 0 ? void 0 : deployment.__typename) === AppDeployment.CONNECT ? descriptorDownloadLink.expand({
      appId,
      buildNumber
    }) : undefined
  };
};
const makeAppScopes = latestVersion => {
  if (latestVersion && latestVersion.deployment && (latestVersion.deployment.__typename === AppDeployment.CONNECT || latestVersion.deployment.__typename === AppDeployment.ECOSYSTEM_CLOUD)) {
    return latestVersion.deployment.scopes;
  }
  return [];
};
export const makeDistribution = (appListingDistribution, appDataFromSearchDistribution, hosting) => {
  var _ref5, _appDataFromSearchDis, _ref6, _appDataFromSearchDis2;
  const preInstalledInSelectedHosting = hosting === AtlassianProductHostingType.Cloud ? appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInCloud : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInServerDC;
  const downloadCount = (_ref5 = (_appDataFromSearchDis = appDataFromSearchDistribution === null || appDataFromSearchDistribution === void 0 ? void 0 : appDataFromSearchDistribution.downloads) !== null && _appDataFromSearchDis !== void 0 ? _appDataFromSearchDis : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.downloadCount) !== null && _ref5 !== void 0 ? _ref5 : 0;
  const installationCount = (_ref6 = (_appDataFromSearchDis2 = appDataFromSearchDistribution === null || appDataFromSearchDistribution === void 0 ? void 0 : appDataFromSearchDistribution.activeInstalls) !== null && _appDataFromSearchDis2 !== void 0 ? _appDataFromSearchDis2 : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.installationCount) !== null && _ref6 !== void 0 ? _ref6 : 0;
  return {
    downloadCount,
    installationCount,
    isPreinstalled: preInstalledInSelectedHosting || false,
    isPreinstalledInAnyHosting: (appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInCloud) || (appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInServerDC) || false
  };
};
export const getAppIdentifier = appDetails => {
  const selectedVersion = getSelectedAppVersion(AtlassianProductHostingType.Cloud, appDetails);
  const {
    deployment
  } = selectedVersion || {};
  if ((deployment === null || deployment === void 0 ? void 0 : deployment.__typename) === 'MarketplaceCloudAppDeployment') {
    return deployment.cloudAppId;
  }
  return appDetails.appKey;
};
function makeAppListingHostingSelectorOptions(appDetails, enableIsolatedCloudChanges, enableFedrampChanges) {
  var _appDetails$isolatedC, _appDetails$isolatedC2, _appDetails$isolatedC3, _appDetails$agcAppVer, _appDetails$agcAppVer2, _appDetails$agcAppVer3;
  let productHostingOptions = [...appDetails.productHostingOptions];
  if (enableIsolatedCloudChanges && (_appDetails$isolatedC = appDetails.isolatedCloudAppVersions) !== null && _appDetails$isolatedC !== void 0 && (_appDetails$isolatedC2 = _appDetails$isolatedC.edges) !== null && _appDetails$isolatedC2 !== void 0 && (_appDetails$isolatedC3 = _appDetails$isolatedC2[0]) !== null && _appDetails$isolatedC3 !== void 0 && _appDetails$isolatedC3.node) {
    productHostingOptions = [...productHostingOptions, HostingTypesWithCloudComplianceBoundaries.IsolatedCloud];
  }
  if (enableFedrampChanges && (_appDetails$agcAppVer = appDetails.agcAppVersions) !== null && _appDetails$agcAppVer !== void 0 && (_appDetails$agcAppVer2 = _appDetails$agcAppVer.edges) !== null && _appDetails$agcAppVer2 !== void 0 && (_appDetails$agcAppVer3 = _appDetails$agcAppVer2[0]) !== null && _appDetails$agcAppVer3 !== void 0 && _appDetails$agcAppVer3.node) {
    productHostingOptions = [...productHostingOptions, HostingTypesWithCloudComplianceBoundaries.GovernmentCloud];
  }
  return productHostingOptions;
}
/* eslint-disable complexity */
// eslint-disable-next-line max-lines-per-function
export default function transformAppListing(args) {
  var _appDetails$serverApp, _appDetails$serverApp2, _appDetails$cloudAppV, _appDetails$cloudAppV2, _appDetails$dataCente, _appDetails$dataCente2, _appDetails$logo, _appDetails$logo2, _highlights$map, _screenshots$map, _appDetails$tagline, _appDetails$summary, _appDetails$tags$mark, _appDetails$tags, _selectedAppVersionCo, _deployment$compatibl, _latestCloudAppVersio;
  const {
    appDetails,
    reviewSummaryDetails,
    enableAppReviewSummaryFromStoreBff,
    appDataFromSearch,
    mediaImageLink,
    mediaImageFromProductListingLink,
    partnerDetailsLink,
    hosting,
    appVersionHistoryLink,
    artifactDownloadLink,
    descriptorDownloadLink,
    appIconLink,
    enableMediaFromProductListing,
    enableIsolatedCloudChanges,
    enableFedrampChanges
  } = args;
  const selectedAppVersion = getSelectedAppVersion(hosting, appDetails);
  const selectedAppVersionConnection = getSelectedAppVersionConnection(hosting, appDetails);
  const latestServerAppVersion = (_appDetails$serverApp = appDetails.serverAppVersions.edges) === null || _appDetails$serverApp === void 0 ? void 0 : (_appDetails$serverApp2 = _appDetails$serverApp[0]) === null || _appDetails$serverApp2 === void 0 ? void 0 : _appDetails$serverApp2.node;
  const latestCloudAppVersion = (_appDetails$cloudAppV = appDetails.cloudAppVersions.edges) === null || _appDetails$cloudAppV === void 0 ? void 0 : (_appDetails$cloudAppV2 = _appDetails$cloudAppV[0]) === null || _appDetails$cloudAppV2 === void 0 ? void 0 : _appDetails$cloudAppV2.node;
  const latestDataCenterAppVersion = (_appDetails$dataCente = appDetails.dataCenterAppVersions.edges) === null || _appDetails$dataCente === void 0 ? void 0 : (_appDetails$dataCente2 = _appDetails$dataCente[0]) === null || _appDetails$dataCente2 === void 0 ? void 0 : _appDetails$dataCente2.node;

  // for all UX purposes, cloud only has 1 version from a user’s POV
  const totalVersionCount = Math.min(1, appDetails.cloudAppVersions.totalCount) + appDetails.serverAppVersions.totalCount + appDetails.dataCenterAppVersions.totalCount;
  const serverCompatibleProducts = (latestServerAppVersion === null || latestServerAppVersion === void 0 ? void 0 : latestServerAppVersion.deployment.compatibleProducts) || [];
  const cloudCompatibleProducts = (latestCloudAppVersion === null || latestCloudAppVersion === void 0 ? void 0 : latestCloudAppVersion.deployment.compatibleProducts) || [];
  const dataCenterCompatibleProducts = (latestDataCenterAppVersion === null || latestDataCenterAppVersion === void 0 ? void 0 : latestDataCenterAppVersion.deployment.compatibleProducts) || [];
  const makeMediaImageFromAMKT = imageId => mediaImageLink.expand({
    imageId
  });
  const makeMediaImageFromProductListing = imageId => mediaImageFromProductListingLink.expand({
    imageId
  });
  const {
    name,
    appKey,
    appId,
    slug,
    privacyPolicyUrl,
    partner,
    programs
  } = appDetails;
  const {
    youtubeId,
    highlights,
    screenshots,
    moreDetails,
    heroImage,
    deployment,
    releaseDate,
    releaseNotes,
    releaseSummary,
    releaseNotesUrl,
    version
  } = selectedAppVersion || {};
  const appScopes = makeAppScopes(selectedAppVersion);
  const listingImageRenderer = enableMediaFromProductListing ? makeMediaImageFromProductListing : makeMediaImageFromAMKT;
  const logoImage = ((_appDetails$logo = appDetails.logo) === null || _appDetails$logo === void 0 ? void 0 : _appDetails$logo.highResolution) || ((_appDetails$logo2 = appDetails.logo) === null || _appDetails$logo2 === void 0 ? void 0 : _appDetails$logo2.original);
  const logo = logoImage ? logoImage.imageUrl || listingImageRenderer(logoImage.id) : appIconLink.expand({
    appKey
  });
  return _objectSpread(_objectSpread({
    appId,
    appKey,
    slug,
    heroImage: makeHeroImage(heroImage, listingImageRenderer),
    logo,
    highlights: (_highlights$map = highlights === null || highlights === void 0 ? void 0 : highlights.map(highlight => makeHighlight(highlight, listingImageRenderer))) !== null && _highlights$map !== void 0 ? _highlights$map : [],
    moreDetails,
    name,
    partner: makePartner(partner, partnerDetailsLink, makeMediaImageFromAMKT),
    privacyPolicyUrl,
    screenshots: (_screenshots$map = screenshots === null || screenshots === void 0 ? void 0 : screenshots.map(screenshot => makeScreenshot(screenshot, listingImageRenderer))) !== null && _screenshots$map !== void 0 ? _screenshots$map : [],
    tagline: (_appDetails$tagline = appDetails.tagline) !== null && _appDetails$tagline !== void 0 ? _appDetails$tagline : '',
    // Tagline is mandatory in the app details form, but historically some apps don't have it
    summary: (_appDetails$summary = appDetails.summary) !== null && _appDetails$summary !== void 0 ? _appDetails$summary : '',
    // Summary is mandatory in the app details form, but historically some apps don't have it
    youtubeId,
    marketingLabels: appDetails.marketingLabels,
    tags: {
      marketingTags: (_appDetails$tags$mark = (_appDetails$tags = appDetails.tags) === null || _appDetails$tags === void 0 ? void 0 : _appDetails$tags.marketingTags) !== null && _appDetails$tags$mark !== void 0 ? _appDetails$tags$mark : []
    },
    categories: appDetails.categories.map(category => ({
      name: category.name
    })),
    reviewSummary: makeReviewSummary(enableAppReviewSummaryFromStoreBff, appDetails.reviewSummary, reviewSummaryDetails),
    watchersInfo: makeWatcherInfo(appDetails.watchersInfo),
    productHostingOptions: makeAppListingHostingSelectorOptions(appDetails, enableIsolatedCloudChanges, enableFedrampChanges),
    appScopes,
    listingStatus: appDetails.listingStatus,
    releaseDate,
    releaseNotes,
    releaseSummary,
    releaseNotesUrl,
    serverCompatibleProducts,
    cloudCompatibleProducts,
    dataCenterCompatibleProducts,
    versionCount: (_selectedAppVersionCo = selectedAppVersionConnection.totalCount) !== null && _selectedAppVersionCo !== void 0 ? _selectedAppVersionCo : 0,
    totalVersionCount,
    version,
    hasDataCenterVersion: !!appDetails.dataCenterAppVersions.totalCount,
    compatibleProducts: (_deployment$compatibl = deployment === null || deployment === void 0 ? void 0 : deployment.compatibleProducts) !== null && _deployment$compatibl !== void 0 ? _deployment$compatibl : [],
    supportDetails: makeSupportDetails({
      appDetails,
      selectedAppVersion,
      hosting: convertToAtlassianHostingType(hosting)
    })
  }, makeResourceLinks({
    appDetails,
    latestVersion: selectedAppVersion,
    appVersionHistoryLink,
    artifactDownloadLink,
    descriptorDownloadLink,
    hosting
  })), {}, {
    createdAt: new Date(appDetails.createdAt),
    distribution: makeDistribution(appDetails.distribution, appDataFromSearch === null || appDataFromSearch === void 0 ? void 0 : appDataFromSearch.distribution, convertToAtlassianHostingType(hosting)),
    installationInstructions: makeInstallationInstructions({
      selectedAppVersion,
      listingImageRenderer
    }),
    deploymentType: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.deployment.__typename,
    paymentModel: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.paymentModel,
    programs: makePrograms(programs),
    licenseType: latestCloudAppVersion === null || latestCloudAppVersion === void 0 ? void 0 : (_latestCloudAppVersio = latestCloudAppVersion.licenseType) === null || _latestCloudAppVersio === void 0 ? void 0 : _latestCloudAppVersio.name
  });
}